export default __webpack_public_path__ + "static/media/SuperHero.59633779.PNG";